import React, { useEffect, useState } from "react";
import { Header } from "../Core/Header";
import { Footer } from "../Core/Footer";
import { useDispatch, useSelector } from "react-redux";
import { cartItemDecreament, cartItemQuantityDecreament, cartItemQuantityIncreament, emptyCart,fetchingState } from "../Redux/Cart-system";
import { toast } from "react-toastify";
import { clearItemFromCart, decreamentCart, increamentCart, removeItemFromCart, ViewCartItems } from "../Services/Operations/ProductAPI";
import Cookies from "js-cookie"

export const Cart = () => {
const dispatch=useDispatch()
 let cartList=(useSelector((state)=>state.cart.cartItems)||[])
 const[load,setLoad]=useState(false)



 const increament=async(item)=>{

    if(item.stock<= item.quantity){
      toast.info("Product stock has reached")
      return
    }
       dispatch(cartItemQuantityIncreament({id:item.id}));
                      await increamentCart(item.id)
 }

 const itemRemove=async(id)=>{
  try{
    const item = cartList.find(item => item.id === id);
  if (!item) {
    return;
  }
    dispatch(cartItemDecreament({id:id}))
    await removeItemFromCart(item.id)
    console.log(cartList);
    
    toast.success("Item removed from cart successfully")
  }catch(error){
    toast.error("Failed to remove item from cart")
    console.log(error);
    
  }

 }

 const totalPrice=async(cart)=>{
  let price=0
   cart.forEach(i=>{
   price += i.productPrice*i.quantity

  })
  return price
 }

 const cartListDesign=(carts)=>{
  let list=[]
  carts.forEach(item=>{
        let newI={
        name:item.productName,
        id:item.productId,
        price:item.productPrice,
        quantity:item.quantity,
        img:item.productImage,
        rate:item.productRate,
        stock:item.stock}

       list=  [newI,...list]

      })
      return list;

 }

 const fetchCartItems=async ()=>{
  try {
    setLoad(true)
    const response=await ViewCartItems()
    console.log(response);
    if(response.status==="success"){
     
        Cookies.set('rndsan_cart', "");
      let price=await totalPrice(response.cart)
      let list=await cartListDesign(response.cart)

      let state={
        cartItems:list,
        total:response.cart.length,
        totalPrice:price
      };

      
       dispatch(fetchingState(state))
      
      
        console.log("state",state,cartList);
    }else{
      toast.info("failed to fetch cart list")
    }
   
    
    
  } catch (error) {
    console.log(error);
    
  }finally{
    setLoad(false)
  }
 }
 useEffect(() => {
   fetchCartItems()
 }, [])

 
 

  return (
    <div>
      <Header/>
      
      <div
        className="modal fade"
        id="searchModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Search by keyword
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body d-flex align-items-center">
              <div className="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  className="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span id="search-icon-1" className="input-group-text p-3">
                  <i className="fa fa-search" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div className="container-fluid page-header py-5">
        <h1 className="text-center text-white display-6">Cart</h1>
        <ol className="Earscrumb justify-content-center mb-0">
          <li className="Earscrumb-item">
            <a href="#">Home</a>
          </li>
          <li className="Earscrumb-item">
            <a href="#">Pages</a>
          </li>
          <li className="Earscrumb-item active text-white">Cart</li>
        </ol>
      </div>
    
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">Products</th>
                  <th scope="col">Name</th>
                  <th scope="col">Price</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Total</th>
                  <th scope="col">Handle</th>
                </tr>
              </thead>
              {
               load? <tbody>
                <tr>
                  <td>Your card data is fetching!!</td>
                </tr>
               </tbody>:
               <tbody>
        {cartList.length>0 ? cartList.map((item, index) =>(
          <tr>
                  <th scope="row">
                    <div className="d-flex align-items-center">
                      <img
                        src="Assets/img/ear4.png"
                        className="img-fluid me-5 rounded-circle"
                        style={{ width: 80, height: 80 }}
                        alt
                      />
                    </div>
                  </th>
                  <td>
                    <p className="mb-0 mt-4">{item.name}</p>
                  </td>
                  <td>
                    <p className="mb-0 mt-4">{item.price}</p>
                  </td>
                  <td>
                    <div
                      className="input-group quantity mt-4"
                      style={{ width: 100,display:"flex",alignItems:"center",justifyContent:"center" }}
                    >
                      {item.quantity>1 ?<div className="input-group-btn">
                        <button className="btn btn-sm btn-minus rounded-circle bg-light border"
                        onClick={async()=>{
                          dispatch(cartItemQuantityDecreament({id:item.id}));
                        await decreamentCart(item.id)
                        }}
                        >
                          <i className="fa fa-minus" />
                        </button>
                      </div>
                      :<div className="input-group-btn"><button 
                     onClick={()=>itemRemove(item.id)}
                    className="btn btn-md rounded-circle bg-light border mt-4">
                      <i className="fa fa-times text-danger" />
                    </button></div>
                      }
                      <p style={{padding:"6px",borderRadius:"5px",margin:"3px",fontWeight:"bold",fontSize:"20px"}}>{item.quantity}</p>
                      <div className="input-group-btn">
                        <button className="btn btn-sm btn-plus rounded-circle bg-light border"
                        onClick={async()=>{
                        await increament(item)
                      }}
                        >
                          <i className="fa fa-plus" />
                        </button>
                      </div>
                    </div>
                  </td>
                  <td>
                    <p className="mb-0 mt-4">{(item.quantity*Number(item.price)).toFixed(2)}</p>
                  </td>
                  <td>
                    <button 
                     onClick={()=>itemRemove(item.id)}
                    className="btn btn-md rounded-circle bg-light border mt-4">
                      <i className="fa fa-times text-danger" />
                    </button>
                  </td>
                </tr>
        ))
            :
            <h4>Cart is emptys, add products to order</h4>    }
                
              </tbody>
              }
              
            </table>
          </div>
          <div>
            <button  onClick={async()=>{
              dispatch(emptyCart());
              await clearItemFromCart()
              }}>
              clear cart
            </button>
          </div>
          <div className="mt-5">
            <input
              type="text"
              className="border-0 border-bottom rounded me-5 py-3 mb-4"
              placeholder="Coupon Code"
            />
            <button
              className="btn border-secondary rounded-pill px-4 py-3 text-primary"
              type="button"
            >
              Apply Coupon
            </button>
          </div>
          <div className="row g-4 justify-content-end">
            <div className="col-8" />
            <div className="col-sm-8 col-md-7 col-lg-6 col-xl-4">
              <div className="bg-light rounded">
                <div className="p-4">
                  <h1 className="display-6 mb-4">
                    Cart <span className="fw-normal">Total</span>
                  </h1>
                  <div className="d-flex justify-content-between mb-4">
                    <h5 className="mb-0 me-4">Subtotal:</h5>
                    <p className="mb-0">{(useSelector((state)=>state.cart.totalPrice)).toFixed(2)}</p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <h5 className="mb-0 me-4">Shipping</h5>
                    <div className>
                      <p className="mb-0">Flat rate: $3.00</p>
                    </div>
                  </div>
                  <p className="mb-0 text-end">Shipping to Ukraine.</p>
                </div>
                <div className="py-4 mb-4 border-top border-bottom d-flex justify-content-between">
                  <h5 className="mb-0 ps-4 me-4">Total Items</h5>
                  <p className="mb-0 pe-4">{useSelector((state)=>state.cart.total)}</p>
                </div>
                <div className="py-4 mb-4 border-top border-bottom d-flex justify-content-between">
                  <h5 className="mb-0 ps-4 me-4">Total</h5>
                  <p className="mb-0 pe-4">{(useSelector((state)=>state.cart.totalPrice)).toFixed(2)}</p>
                </div>
                <a href="/checkout">
                <button
                  className="btn border-secondary rounded-pill px-4 py-3 text-primary text-uppercase mb-4 ms-4"
                  type="button"

                >
                  Proceed Checkout
                </button></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer/>
    </div>
  );
};
